import { produce } from "immer";
import {
  resetSsrData,
  updateSsrData,
} from "./actions";

const initialSsrDataState = {
  slug: '',
  slugs: [],
  type: '',
};

export const ssrDataSlice = (set, get) => ({
  ...initialSsrDataState,
});

export const ssrDataActions = (set, get) => ({
  [resetSsrData]: () => {
    set((state) => ({
      ...state,
      ssrData: {
        ...initialSsrDataState,
      },
    }));
  },
  [updateSsrData]: (payload) => {
    set((state) => ({
      ...state,
      ssrData: payload ? {
        ...state.ssrData,
        ...payload,
      } : {
        ...initialSsrDataState
      },
    }));
  },
});
